var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25176 15.4875C3.04934 15.5549 2.86991 15.6778 2.73389 15.8422C2.59786 16.0066 2.5107 16.2058 2.48231 16.4173C2.45392 16.6288 2.48546 16.8439 2.57332 17.0384C2.66118 17.2328 2.80185 17.3987 2.97932 17.5171L13.0598 23.0741C13.2477 23.1776 13.461 23.226 13.6752 23.2137C13.8893 23.2015 14.0957 23.129 14.2705 23.0047L24.9798 15.3682C25.4973 15.0216 26.1163 15.6406 25.7697 16.1581L18.1332 26.8674C18.0089 27.0422 17.9364 27.2486 17.9241 27.4627C17.9119 27.6769 17.9603 27.8902 18.0638 28.0781L23.6208 38.1586C23.7392 38.336 23.9051 38.4767 24.0995 38.5646C24.294 38.6524 24.5091 38.684 24.7206 38.6556C24.9321 38.6272 25.1313 38.54 25.2957 38.404C25.4601 38.268 25.583 38.0886 25.6504 37.8861L36.1292 6.44997C36.1958 6.24925 36.2054 6.03393 36.1567 5.82809C36.108 5.62226 36.003 5.43403 35.8534 5.28447C35.7039 5.13491 35.5156 5.0299 35.3098 4.98121C35.104 4.93252 34.8886 4.94205 34.6879 5.00874L3.25176 15.4875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSend);
export default __webpack_public_path__ + "static/media/icon_Send.739d229d3f58c18f2694d8fe7cb9d2dc.svg";
export { ForwardRef as ReactComponent };